var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import stylesGlobal from '../_sds-breadcrumbs-global.lit.scss';
import styles from './sds-breadcrumbs-item.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 *  Breadcrumbs component that renders links for breadcrumbs and can render given content into that link.
 *
 *  @slot The slot holding content of the breadcrumbs
 */
let SdsBreadcrumbsItem = (() => {
    var _SdsBreadcrumbsItem_disabled_accessor_storage, _SdsBreadcrumbsItem_href_accessor_storage, _SdsBreadcrumbsItem_label_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-breadcrumbs-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    var SdsBreadcrumbsItem = _classThis = class extends _classSuper {
        /**
         * True if breadcrumbs-item is disabled
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsBreadcrumbsItem_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsItem_disabled_accessor_storage, value, "f"); }
        /**
         * Href of breadcrumbs-item
         * @attr
         */
        get href() { return __classPrivateFieldGet(this, _SdsBreadcrumbsItem_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsItem_href_accessor_storage, value, "f"); }
        /**
         * Label of breadcrumbs-item
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsBreadcrumbsItem_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsItem_label_accessor_storage, value, "f"); }
        connectedCallback() {
            if (!this.hasAttribute('role')) {
                this.setAttribute('role', 'listitem');
            }
            super.connectedCallback();
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-breadcrumbs-item', this.stylesGlobal.cssText);
            if (this.href && !this.disabled) {
                return html ` <a
                    class="sds-breadcrumbs-item"
                    href="${this.href}"
                    tabindex="0"
                    ?disabled="${this.disabled}"
                >
                    <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                </a>
                <span
                    part="sds-breadcrumbs-item-separator"
                    class="sds-breadcrumbs-item-separator"
                    aria-hidden="true"
                    >/</span
                >`;
            }
            else {
                return html ` <span
                    class="sds-breadcrumbs-item"
                    ?disabled="${this.disabled}"
                    aria-current="page"
                >
                    <sds-clipped-text basic text="${this.label}"></sds-clipped-text>
                </span>
                <span
                    part="sds-breadcrumbs-item-separator"
                    class="sds-breadcrumbs-item-separator"
                    aria-hidden="true"
                    >/</span
                >`;
            }
        }
        constructor() {
            super(...arguments);
            this.stylesGlobal = stylesGlobal;
            _SdsBreadcrumbsItem_disabled_accessor_storage.set(this, __runInitializers(this, _disabled_initializers, false));
            _SdsBreadcrumbsItem_href_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _href_initializers, '')));
            _SdsBreadcrumbsItem_label_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _label_initializers, '')));
            __runInitializers(this, _label_extraInitializers);
        }
    };
    _SdsBreadcrumbsItem_disabled_accessor_storage = new WeakMap();
    _SdsBreadcrumbsItem_href_accessor_storage = new WeakMap();
    _SdsBreadcrumbsItem_label_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsBreadcrumbsItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _disabled_decorators = [property({ type: Boolean })];
        _href_decorators = [property({ type: String })];
        _label_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsBreadcrumbsItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsBreadcrumbsItem = _classThis;
})();
export { SdsBreadcrumbsItem };
